import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { AuthProvider, useAuth } from './components/AuthContext';
import theme from './theme'; 
import ResultPage from './components/ResultPage';
import ExitResult from './components/ExitResultPage'; 
import UsernamePage from './components/usernamepage'; 
import FAQPage from './components/FAQPage';
import Footer from './components/Footer';
import RemedialResultPage from './components/RemedialResultPage';
import RemedialUsernamePage from './components/RemedialUsernamePage';
import TvetUsernamePage from './components/TvetUsernamePage';
import TvetResultPage from './components/TvetResultPage';
import TdpUsernamePage from './components/TdpUsernamePage';
import TdpResultPage from './components/TdpResultPage';
import TdpVerificationPage from './components/TdpVerificationPage';
import NgatUsernamePage from './components/NgatUsernamePage';
import NgatResultPage from './components/NgatResultPage';
import NgatVerificationPage from './components/NgatVerificationPage';
import ExitExamVerificationPage from './components/ExitExamVerificationPage';
import RemedialVerificationPage from './components/RemedialVerificationPage';
import './index.css';

// Layout component that includes the footer
const Layout = () => {
  return (
    <div>
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
           <AppRoutes />
       </Router>
    </ThemeProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
            <Route path="/" element={<ResultPage />} />
            <Route path="/usernamepage" element={<UsernamePage />} />
             <Route path="/result" element={<ExitResult />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/remedial-result" element={<RemedialResultPage />} />
        <Route path="/remedial-usernamepage" element={<RemedialUsernamePage />} />
        <Route path="/tvet-username" element={<TvetUsernamePage />} />
        <Route path="/tvet-result" element={<TvetResultPage />} />
        <Route path="/tdp-username" element={<TdpUsernamePage />} />
        <Route path="/tdp-result" element={<TdpResultPage />} />
        <Route path="/tdp/:userToken" element={<TdpVerificationPage />} />
        <Route path="/ngat-username" element={<NgatUsernamePage />} />
        <Route path="/ngat-result" element={<NgatResultPage />} />
        <Route path="/ngat/:userToken" element={<NgatVerificationPage />} />
        <Route path="/verify-exit-exam/:username" element={<ExitExamVerificationPage />} />
        <Route path="/verify-remedial/:username" element={<RemedialVerificationPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
        </Routes>
  );
}

export default App;
